import $ from 'jquery';
import constants from 'Constants.js';
import { View } from 'backbone';
import BaseTableView2 from 'properties/BaseTableView2.js'
import Template from 'behaviors/properties/main/return.ejs';
import selectFieldModal from 'common-views/SelectFieldModalView';
import eventBus from 'EventBus';
import util from 'util/Util.js';
//=====================================================================
//
// An instance of this view represents a Return.
//
// Casey Justus, May 17, 2016
//
//=====================================================================

class MainReturnView extends BaseTableView2 {

    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE2;
        this.minRows = 6;
        this.$sendSelector = '#gbox_propMainTable > div.ui-jqgrid-view > div.ui-jqgrid-bdiv';
        this.$returnSelector = '#gbox_propMainTable2 > div.ui-jqgrid-view > div.ui-jqgrid-bdiv';

        this.events = {
            "click .itemNew"              : "itemNew",
            "click .itemRemove"           : "itemRemove",
            "click .itemUp": "itemUp",
            "click .itemDown": "itemDown",
            "change input[type=checkbox]": "itemCheck"
        };

        this.listenTo(this.model, 'change', this.render); 

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }

        return this;
    } 

    itemCheck(e) {
        this.model.set('sendPos', $(this.$sendSelector).scrollTop(), constants.MODEL_SILENT);
        this.model.set('returnPos', $(this.$returnSelector).scrollTop(), constants.MODEL_SILENT);

        let parentCell = $(e.currentTarget).parent();
        let i = $(e.currentTarget).closest('tr').index() - 1;
        let gridData2 = this.model.get('gridData2');

        let title = parentCell.attr('aria-describedby').split("_")[1];
        if (title === 'show') {
            gridData2[i].show = e.currentTarget.checked ? 'selected' : '';
            this.model.attributes.Request.Receive.parameter[i]._show =  e.currentTarget.checked ? 'true' : 'false';
        } else {
            gridData2 = this.updateSelectionCheckboxStatus(i, gridData2, e.target, title);
        }

        this.model.set('gridData2', gridData2, {silent: true});
    }

    // Method that disables the selection checkbox if the others checkboxes are not selected.
    updateSelectionCheckboxStatus(currentRow, gridData2, clickedCheckbox, title) {
        let selectionCheckbox=null;
        let type = 'field';
        let clearTarget = false;

        switch (title) {
            case 'caption':
                gridData2[currentRow].caption = clickedCheckbox.checked ? 'selected':'';
                clearTarget = gridData2[currentRow].value !== 'selected';
                break;
            case 'value':
                gridData2[currentRow].value = clickedCheckbox.checked ? 'selected':'';
                clearTarget = gridData2[currentRow].caption !== 'selected';
                break;
            case 'select':
                gridData2[currentRow].select = clickedCheckbox.checked ? 'selected':'';
                // emptyDefaultItem = true
                if (clickedCheckbox.checked) {
                    this.model.attributes.Request.Receive.parameter[currentRow]._emptyDefaultItem = "true";
                } else {
                    this.model.attributes.Request.Receive.parameter[currentRow]._emptyDefaultItem = "false";
                }

                break;
        }

        // Set Request Values for use in Saving.
        if (gridData2[currentRow].caption && gridData2[currentRow].value) {
            type = 'items'
        } else if (gridData2[currentRow].caption) {
            type = 'itemsCaption';
        } else if (gridData2[currentRow].value) {
            type = 'itemsValue';
        } else {
            type = 'field';
        }
        this.model.attributes.Request.Receive.parameter[currentRow]._type = type;
        if (clearTarget){
            this.model.attributes.Request.Receive.parameter[currentRow]._value = '';
            gridData2[currentRow].target = '';
            gridData2[currentRow].select = '';
            this.model.trigger('change');
        }

        return gridData2;
    }

    onCellSelect(rowid, iCol, cellcontent,e){

        this.model.set('sendPos', $(this.$sendSelector).scrollTop(), constants.MODEL_SILENT);
        this.model.set('returnPos', $(this.$returnSelector).scrollTop(), constants.MODEL_SILENT);
        this.model.set('cellContent', (cellcontent && cellcontent !== "&nbsp;")?cellcontent:undefined, constants.MODEL_SILENT);
        
        const rowData = $(this.gridEl).getRowData(rowid);
        if (rowData['isDefault']) {
            e.preventDefault();
            return;
        }

        
        const colNames = this.model.get('colNames2');
        if (colNames[iCol] !== 'Target' ) {
            return;
        }

        const factoryKey= 'modal';
        let gridData=this.model.get('gridData2');
        this.model.set('hideSelectFields', (gridData[rowid].value === 'selected' || gridData[rowid].caption === 'selected'), { silent: true });
        
        if(cellcontent)
        {
            this.model.set("dataSelectedItemId", 
                this.model.attributes.Request.Receive.parameter[rowid]._value, {silent:true});
        }
        
        var sfModal = new selectFieldModal({model: this.model});
        sfModal.render().then((selectedField)=>{
            gridData[rowid].target=selectedField.name;
            this.model.set('gridData2',gridData);

            this.model.attributes.Request.Receive.parameter[rowid]._value = selectedField.id;

            this.render();
        });
    }

    render() {
        super.render();

        let gridData = $(this.gridEl).jqGrid('getRowData');

        let size = gridData.length;
        
        if (size <= this.minRows) {
            var newRow = {
                'search': '',
                'name': '',
                'target': '',
                'source': '',
                'formula': '',
                'isDefault': true
            };
            for (let i=size; i<this.minRows; ++i) {
                $(this.gridEl).addRowData((gridData.length + 1), newRow);
            }
        }

        $(this.gridEl).jqGrid('setGridHeight', 'auto');

        $(this.$sendSelector).scrollTop(this.model.get('sendPos'));
        $(this.$returnSelector).scrollTop(this.model.get('returnPos'));
    }

}

export default MainReturnView;
